/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetMiscTrackingQueryRequest = {
  tracking_number: string;
  carrier_code?: string | undefined;
  phone?: string | undefined;
};

export const GetMiscTrackingQueryRequest$zodSchema: z.ZodType<
  GetMiscTrackingQueryRequest
> = z.object({
  carrier_code: z.string().describe(
    "快递公司编码（可选）。不填写时系统会自动识别，填写后可加快查询速度。",
  ).optional(),
  phone: z.string().describe(
    "收件人手机尾号，4位数字（可选）。部分快递公司需要验证手机尾号才能查询详细物流信息。",
  ).optional(),
  tracking_number: z.string().describe(
    "快递单号，通常是一串10-20位的数字或字母数字组合。",
  ),
});

/**
 * 当前没有查询到物流轨迹时会返回 404，并附带错误码和提示信息。如果返回此错误，建议尝试传入 `phone` 参数（收件人手机尾号）再次查询。
 */
export type GetMiscTrackingQueryNotFoundResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetMiscTrackingQueryNotFoundResponseBody$zodSchema: z.ZodType<
  GetMiscTrackingQueryNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe(
  "当前没有查询到物流轨迹时会返回 404，并附带错误码和提示信息。如果返回此错误，建议尝试传入 `phone` 参数（收件人手机尾号）再次查询。",
);

/**
 * 参数错误，请检查快递单号是否正确。
 */
export type GetMiscTrackingQueryBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetMiscTrackingQueryBadRequestResponseBody$zodSchema: z.ZodType<
  GetMiscTrackingQueryBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("参数错误，请检查快递单号是否正确。");

export type Track = { time?: string | undefined; context?: string | undefined };

export const Track$zodSchema: z.ZodType<Track> = z.object({
  context: z.string().optional(),
  time: z.string().optional(),
});

export type GetMiscTrackingQueryData = {
  tracking_number?: string | undefined;
  carrier_code?: string | undefined;
  carrier_name?: string | undefined;
  track_count?: number | undefined;
  tracks?: Array<Track> | undefined;
};

export const GetMiscTrackingQueryData$zodSchema: z.ZodType<
  GetMiscTrackingQueryData
> = z.object({
  carrier_code: z.string().optional(),
  carrier_name: z.string().optional(),
  track_count: z.int().optional(),
  tracking_number: z.string().optional(),
  tracks: z.array(z.lazy(() => Track$zodSchema)).optional(),
});

/**
 * 查询成功！返回快递的完整物流轨迹。
 */
export type GetMiscTrackingQueryResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
  data?: GetMiscTrackingQueryData | undefined;
};

export const GetMiscTrackingQueryResponseBody$zodSchema: z.ZodType<
  GetMiscTrackingQueryResponseBody
> = z.object({
  code: z.string().optional(),
  data: z.lazy(() => GetMiscTrackingQueryData$zodSchema).optional(),
  message: z.string().optional(),
}).describe("查询成功！返回快递的完整物流轨迹。");

export type GetMiscTrackingQueryResponse =
  | GetMiscTrackingQueryResponseBody
  | GetMiscTrackingQueryBadRequestResponseBody
  | GetMiscTrackingQueryNotFoundResponseBody;

export const GetMiscTrackingQueryResponse$zodSchema: z.ZodType<
  GetMiscTrackingQueryResponse
> = z.union([
  z.lazy(() => GetMiscTrackingQueryResponseBody$zodSchema),
  z.lazy(() => GetMiscTrackingQueryBadRequestResponseBody$zodSchema),
  z.lazy(() => GetMiscTrackingQueryNotFoundResponseBody$zodSchema),
]);
